module.exports = __webpack_public_path__ + "static/binder1-8dbc2c0c90b5fbd1970e51dd3055cd3e.png";